module.exports = __webpack_public_path__ + "h5/img/noCollection.46d9f620.png";